import { apiRequest } from "../api";

export const getProducts = (query: string) =>
  apiRequest(`/products${query ? `?${query}` : ""}`, "GET");
export const getProductFormMeta = () => apiRequest("/products/form-meta", "GET");
export const getProduct = (id: string) => apiRequest(`/products/${id}`, "GET");
export const saveProduct = (endpoint: string, method: string, payload: unknown) =>
  apiRequest(endpoint, method, payload);
export const deleteProduct = (id: string) =>
  apiRequest(`/products/${id}`, "DELETE");
